/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

/* Internal Imports */
/* Components */
/* Services */
/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * Renders Json Table UI YouTube Video3 Column Component
 * @param {Object} sectionContent - Data from api
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Json Table UI YouTube Video3 Column Component.
 */
const JsonTableUIYouTubeVideo3Column = ({ sectionContent, region, lang }) => {
  const GetEmbedUrl = url => {
    return url && url.indexOf('/watch') > -1
      ? `https://www.youtube.com/embed/${url?.split('=')[1]}`
      : url;
  };

  return (
    <Flex
      flexDir={{
        base: 'column',
        lg: 'row',
      }}
      id="iframe-box"
      justifyContent={'space-between'}
      placeItems={'center'}
      maxW={{ base: 'inherit', md: '980px' }}
      m={{ base: 'inherit', xl: '0 auto' }}
    >
      {sectionContent.data[1] != undefined && (
        <Box
          width={{ xl: '264px !important', sm: '80% !important' }}
          height={{ xl: '152px', sm: '100%' }}
          boxShadow="0 0 34px 0 rgb(0 0 0 / 50%)"
          margin={{
            xl: '20px 10px 20px 10px',
            base: '20px auto',
          }}
          className="LiteYoutube"
        >
          <LiteYouTubeEmbed
            id={
              GetEmbedUrl(sectionContent?.data['1'])?.split('/')[
                GetEmbedUrl(sectionContent?.data['1'])?.split('/').length - 1
              ]
            }
            cookie
          />
        </Box>
      )}
      {sectionContent.data[2] != undefined && (
        <Box
          width={{ xl: '264px !important', sm: '80% !important' }}
          height={{ xl: '152px', sm: '100%' }}
          boxShadow="0 0 34px 0 rgb(0 0 0 / 50%)"
          margin={{
            xl: '20px 10px 20px 10px',
            base: '20px auto',
          }}
          className="LiteYoutube"
        >
          <LiteYouTubeEmbed
            id={
              GetEmbedUrl(sectionContent?.data['2'])?.split('/')[
                GetEmbedUrl(sectionContent?.data['2'])?.split('/').length - 1
              ]
            }
            cookie
          />
        </Box>
      )}
      {sectionContent.data[3] != undefined && (
        <Box
          width={{ xl: '264px !important', sm: '80% !important' }}
          height={{ xl: '152px', sm: '100%' }}
          boxShadow="0 0 34px 0 rgb(0 0 0 / 50%)"
          margin={{
            xl: '20px 10px 20px 10px',
            base: '20px auto',
          }}
          className="LiteYoutube"
        >
          <LiteYouTubeEmbed
            id={
              GetEmbedUrl(sectionContent?.data['3'])?.split('/')[
                GetEmbedUrl(sectionContent?.data['3'])?.split('/').length - 1
              ]
            }
            cookie
          />
        </Box>
      )}
      <style jsx global>
        {`
          @media only screen and (max-width: 600px) {
            .LiteYoutube {
              width: 80% !important;
            }
          }
        `}
      </style>
    </Flex>
  );
};

export default JsonTableUIYouTubeVideo3Column;
